import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Banner from "./components/Banner";
import PricingCards from "./components/Pricing";
import Testomonials from "../../components/testomonials";
import RetailAvailability from "./components/RetailAvailibilty";
import ClinicalStudies from "../../components/Studies";
import Stop from "../../assets/landingPage/stopNew.png";
import ClickBank from "../../components/Footer";
import { LOADER_STATUS } from "../../constant/Data";
import HeroVitalityBox from "./components/HeroVitalityBox";
import HeroSection from "./components/HeroSection";
import Header from "./components/Header";
import ElizabethSection from "./components/ElizabethSection";
import TestimonialSection from "./components/testimonialSection";
import VitalityBoxx from "./components/VitalityBox";
import Steppers from "./components/Steppers";
import LimitedTime from "./components/LimitedTime";
import DeskofElizabeth from "./components/DeskofElizabeth";
import SpecialOfferPlans from "./components/SpecialOfferPlans";
import VitalityBoxShipping from "./components/VitalityBoxShipping";
import MoneyBackGuarantee from "./components/MoneyBackGuarantee";
import VitalityBoxCards from "./components/VitalityBoxCards";
import Footer from "./components/Footer";

















function VitalityBox() {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
  const pricingRef = useRef(null);
  const [startTimer, setStartTimer] = useState(false);
  const [isVideoPlay, setIsVideoPlay] = useState(false);

  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);

      // Check if there is any query parameter
      const hasAnyParam = Array.from(params.entries()).length > 0;

      setIsVideoParamExists(hasAnyParam);

      setIsShowVsl(1);
    }
  }, [location]);

  const maximizeVideo = () => {
    setIsVideoPlay(LOADER_STATUS.PLAY);

    // console.log("Maximize Video", "LOADER", isVideoPlay);
    setIsVideoPlay(LOADER_STATUS.PLAY);
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.maxWidth = "100%";
    video.style.height = "100vh";
    video.style.padding = "0px";
    video.style.backgroundColor = "#000";

    vidwrapper.style.height = "100vh";
    vidwrapper.style.width = "100%";
    vidwrappervid.style.height = "100vh";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "contain";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "contain";
    }
  };

  const minimizeVideo = () => {
    // console.log("Minimize Video");
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.padding = "20px";
    video.style.maxWidth = "900px";
    video.style.height = "480px";
    video.style.backgroundColor = "transparent";

    vidwrapper.style.height = "100%";
    vidwrapper.style.width = "100%";

    vidwrappervid.style.height = "100%";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "cover";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "cover";
    }
  };

  useEffect(() => {
    const SECONDS_TO_DISPLAY = 721;
    let attempts = 0;
    let elsDisplayed = false;

    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

    const showHiddenElements = () => {
      elsDisplayed = true;
      setIsVisible(true);
      localStorage.setItem(alreadyDisplayedKey, true);

      const player = window.smartplayer.instances?.[0];
      const currentTime = player?.video?.currentTime;
      // console.log(`CTA dropped at Current video time: ${currentTime}`);
    };

    const startWatchVideoProgress = () => {
      if (
        typeof window.smartplayer === "undefined" ||
        !(window.smartplayer.instances && window.smartplayer.instances.length)
      ) {
        if (attempts >= 10) return;
        attempts += 1;
        return setTimeout(() => {
          startWatchVideoProgress();
        }, 1000);
      }
      const player = window.smartplayer.instances[0];
      player.on("timeupdate", () => {
        if (player.smartAutoPlay === false) {
          setIsVideoPlay(LOADER_STATUS.PLAY);
          maximizeVideo();
        }

        if (elsDisplayed || player.smartAutoPlay) return;
        const currentTime = player.video.currentTime;
        // console.log("Current video time:", currentTime);

        if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
        showHiddenElements();
      });

      player.on("pause", () => {
        setIsVideoPlay(LOADER_STATUS.PAUSE);
        minimizeVideo();
      });
    };

    if (alreadyElsDisplayed === "true") {
      setTimeout(() => {
        showHiddenElements();
      }, 100);
    } else {
      startWatchVideoProgress();
    }
  }, []);

  useEffect(() => {
    if (isVisible && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (pricingRef.current) observer.observe(pricingRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !startTimer) {
      setStartTimer(true);
    }
  }, [isVisible, startTimer]);

  const skipVideoAndShowCTA = () => {
    const video = document.querySelector("video");
    if (video) {
      video.currentTime = 721;
      video.dispatchEvent(new Event("timeupdate"));
    }
    setIsVisible(true);
  };






    const offerCardsRef = useRef(null);


  return (
    <>
      <Helmet>
        {/* VisiSmart Code - DO NOT MODIFY */}
        <script async type="text/javascript">
          {`

              <script async type='text/javascript'>window.visiopt_code=window.visiopt_code||(function(){var visi_wid=989,visi_pid=102,visi_flicker_time=4000,visi_flicker_element='html',c=false,d=document,visi_fn={begin:function(){var a=d.getElementById('visi_flicker');if(!a){var a=d.createElement('style'),b=visi_flicker_element?visi_flicker_element+'{opacity:0!important;background:none!important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','visi_flicker');a.setAttribute('type','text/css');if(a.styleSheet){a.styleSheet.cssText=b;}else{a.appendChild(d.createTextNode(b));}h.appendChild(a);}},complete:function(){c=true;var a=d.getElementById('visi_flicker');if(a){a.parentNode.removeChild(a);}},completed:function(){return c;},pack:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){visi_fn.complete();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){visi_fn.begin();setTimeout(function(){visi_fn.complete()},visi_flicker_time);this.pack('https://visiopt.com/client/js_test/test.'+visi_wid+'.'+visi_pid+'.js');return true;}};window.visiopt_code_status=visi_fn.init();return visi_fn;}());</script>
       `}
        </script>
        {/* End Of VisiSmart Code */}
      </Helmet>
      {isVideoParamExists !== null && (
        <div className="w-full">
            {isVideoParamExists ? (
            <>
              <Header />
              <HeroSection />
              <HeroVitalityBox />
              <ElizabethSection />
              <TestimonialSection />
              <VitalityBoxx />
              <Steppers />
              <LimitedTime />
              <DeskofElizabeth />
              <div className="md:mt-0 mt-6" id="offerCards" ref={offerCardsRef}>
                <div>
                  <div className="max-w-md mx-auto text-center px-6">
                    <h2 className="text-[36px] font-bold text-[#204058]">
                      SPECIAL OFFER
                    </h2>
                    <div className="flex items-center justify-center my-2">
                      <hr className="flex-grow max-w-[80px] border-gray-300" />
                      <span className="mx-3 text-[#204058] text-[24px] font-normal">
                        Select Your Package
                      </span>
                      <hr className="flex-grow max-w-[80px] border-gray-300" />
                    </div>
                  </div>
                  <SpecialOfferPlans />
                  <VitalityBoxShipping />
                  <MoneyBackGuarantee />
                </div>
              </div>
              <VitalityBoxCards offerCardsRef={offerCardsRef} />
              <ClinicalStudies />
            </>
          ) : (
            <>
              <PricingCards />
              <RetailAvailability />
              <ClinicalStudies />
            </>
          )}
        </div>
      )}
    </>
  );
}

export default VitalityBox;
